export default __webpack_public_path__ + "static/media/marriage.6c93901e.png";